import { get_url_deal } from '@/utils/commons'
import request from '@/utils/request'

/* 关于我们*/
export function get_about_data(data) {
  const url = get_url_deal('about/selectAbout.json', data)
  return request.get(url)
}

/* ---------------------- 发展历程 ------------------------------*/
export function get_development_data(data) {
  const url = get_url_deal('development/selectDevelopment.json', data)
  return request.get(url)
}
